import React, { Component } from "react";
import { LoginForm } from "./../../components/LoginForm/LoginForm";
import api from "../../utils/api";
import {
  storeAccessToken,
  storeUser,
  getUser,
  storeServiceTypesMaster,
  storeStatesMaster,
  getCookie,
} from "../../utils/localStorage";
// import axios from "axios";
import axios from "./../../utils/axios";
// import values from 'lodash/values';
import Cookies from "universal-cookie";
import { toast } from "react-toastify";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoading:false,
    };
  }

  async componentDidMount() {
    // localStorage.clear();
    const user = getUser();
    const ssoKey = getCookie("sso_key");
    console.log(ssoKey);
    console.log("^^ssokey^^");
    if (ssoKey) {
      // eslint-disable-next-line no-unused-vars
      const { data } = await api.loginWithSso({ sso_key: ssoKey });
      this.handlePostLoginSuccess(data);
    } else {
      if (user) {
        const roleResponse = await api.getUserRoles();
        this.redirectToHome(roleResponse, user);
      }
    }
  }

  handleInputChange = ({ name, value }) => {
    this.setState({ [name]: value });
  };

  handleLoginClick = () => {
    //make server call. store user details in redux store.
    this.setState({isLoading:true});
    const { username: email, password } = this.state;
    this.setState({ error: "" });
    api
      .login({ email, password })
      .then(async ({ data }) => {
        this.handlePostLoginSuccess(data);
      })
      .catch((error) => {
        this.setState({isLoading:false});
        if (!error.response) return;
        const { status } = error.response;
        if (status === 400) {
          this.setState({
            error: "Invalid username or password",
          });
        }
      });
  };

  handleClearClick = () => {
    this.setState({isLoading:true});
    const cookies = new Cookies();
    localStorage.clear();
        cookies.remove('sso_key', { path: '/', domain: '.deasra.in'});
        cookies.remove('token', { path: '/', domain: '.deasra.in'});
        cookies.remove('sso_key_wp', { path: '/', domain: '.deasra.in'});
        cookies.remove('IsUserAuthenticated', { path: '/', domain: '.deasra.in'});
        this.setState({isLoading:false});
        toast(`Session cleared successfully.`, {
          autoClose: 5000,
          type: toast.TYPE.SUCCESS,
        });
        return;
  };

  handleGoogleLoginSuccess = (data) => {
    const { accessToken: access_token } = data;
    api
      .loginWithGoogle({ access_token })
      .then(({ data }) => {
        this.handlePostLoginSuccess(data);
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
      });
  };

  handlePostLoginSuccess = async (data) => {
    const { token } = data;
    const cookies = new Cookies();
    console.log(cookies.get("sso_key"));
    if (data["sso_key"]) {
      cookies.set("sso_key", data["sso_key"], {
        path: "/",
        domain: ".deasra.in",
      });
    }
    cookies.set("token", "Token " + data["token"], {
      path: "/",
      domain: ".deasra.in",
    });
    storeUser(data);
    storeAccessToken(token);
    const [res1, res2] = await this.fetchMasterData();
    const { data: masterStates } = res1;
    const { data: masterTypes } = res2;
    storeServiceTypesMaster(masterTypes);
    storeStatesMaster(masterStates);
    const roleResponse = await api.getUserRoles();
    this.setState({isLoading:false});
    this.redirectToHome(roleResponse, data);
  };

  fetchMasterData = () => {
    const r1 = api.getMasterServiceStates();
    const r2 = api.getMasterServiceTypes();
    return axios.all([r1, r2]);
  };

  /**
   * if system admin, take to users list page.
   * otherwise, take to services list.
   */
  redirectToHome = (response, user) => {
    const { data: rolesData } = response;
    let adminRoleKey = "";
    Object.entries(rolesData).forEach(([key, value]) => {
      if (value === "BUSINESS_ADMIN") {
        adminRoleKey = parseInt(key);
      }
    });
    const hasAdminRole = user.role.includes(adminRoleKey);
    const hasDashboard = user.role[0] === 12 ? true : false
    const hasJpmcRole = user.role[0] === 13 ? true : false;
    const threeSixtyUser = user.role[0] === 20 ? true : false;
    if (hasAdminRole) {
      this.props.history.push("/home/admin-service-requests/");
    } else if(hasDashboard){
      this.props.history.push("/home/newandengagedusers");
    } else if(hasJpmcRole){
      this.props.history.push("/home/jpmcdashboard");
    }else if(threeSixtyUser){
      this.props.history.push("/home/three-sixty-degree-view-new/");
    } else {
      this.props.history.push("/home/my-service-requests");
    }
  };

  render() {
    return (
      <div>
        <LoginForm
          onInputChange={this.handleInputChange}
          onLoginClick={this.handleLoginClick}
          onGoogleLoginSuccess={this.handleGoogleLoginSuccess}
          error={this.state.error}
          isLoading={this.state.isLoading}
          onClearClick={this.handleClearClick}
        />
        <div className="text-center">
          <div className="d-inline-flex">
            <div className="mr5">
              <a href="http://www.deasra.in">Help</a>
            </div>
            <div className="ml5">
              <a href="http://www.deasra.in">Contact Us</a>
            </div>
          </div>
          <div>
            <span>© 2020 deAsra Foundation. </span>
            <a
              className="text-help"
              href="http://www.deasra.in"
              target="_blank"
              rel="noopener noreferrer"
            ></a>
          </div>
        </div>
      </div>
    );
  }
}

export default Login;
